module.exports = __webpack_public_path__ + "img/banner-risk.8dec66fa.jpg";